package com.rainbowclubs.rainbow.data.models

import kotlinx.serialization.Serializable

@Serializable
data class User(
    val id: String?,
    val name: String?,
    val email: String?,
    val createdAt: String?,
)